import { render, staticRenderFns } from "./order-map.vue?vue&type=template&id=2c2100e6&scoped=true&"
import script from "./order-map.vue?vue&type=script&lang=js&"
export * from "./order-map.vue?vue&type=script&lang=js&"
import style0 from "./order-map.vue?vue&type=style&index=0&id=2c2100e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2100e6",
  null
  
)

export default component.exports